<template>
  <div class="containerdiv">
    <van-image
      lazy-load
      class="smallVideodiv"
      :src="live.cover&&live.cover.length>0?live.cover[0]:''"
    />
    <!-- 团购横幅 -->
    <div
      class="goup-div themeBGColor d-flex flex-row align-items-center border-bottom"
      v-if="live.marketingCampaignType==1"
    >
      <div class="flex-1 pl-3 pr-3 pt-1 pb-1">
        <div class="fs-22 text-white d-flex flex-row align-items-center">
          <span class="fs-16">¥</span>
          {{live.marketingCampaignPrice}}
          <span
            class="fs-12 border ml-1 pl-1 pr-1"
          >{{live.maxMemberCount}}人拼</span>
        </div>
        <div class="fs-14 text-white">
          <span class="fs-12">单价买</span>
          ¥{{live.price}}
          <!-- <span class="fs-12 m-price">¥{{live.nominalPrice}}</span> -->
        </div>
      </div>
      <div class="bg-white p-2 d-flex flex-column justify-content-around align-items-center">
        <div class="fs-14 themeFontColor">距拼购结束还剩</div>
        <div class="d-flex flex-row justify-content-around align-items-center">
          <div class="p-1 fs-14">{{time.d}}天</div>
          <div class="themeBGColor text-white p-1 fs-12">{{time.h>9?time.h:'0'+time.h}}</div>
          <div :style="{marginBottom:'0.08rem'}" class="p-1 fs-12">:</div>
          <div class="themeBGColor text-white p-1 fs-12">{{time.m>9?time.m:'0'+time.m}}</div>
          <div :style="{marginBottom:'0.08rem'}" class="p-1 fs-12">:</div>
          <div class="themeBGColor text-white p-1 fs-12">{{time.s>9?time.s:'0'+time.s}}</div>
        </div>
      </div>
    </div>

    <!-- 限时折扣横幅 -->
    <div
      class="goup-div themeBGColor d-flex flex-row align-items-center border-bottom"
      v-if="live.marketingCampaignType==2"
    >
      <div class="flex-1 pl-3 pr-3 pt-1 pb-1">
        <div class="fs-22 text-white d-flex flex-row align-items-center">
          <span class="fs-16">¥</span>
          {{live.marketingCampaignPrice}}
          <span class="fs-12 border ml-1 pl-1 pr-1">现实折扣</span>
        </div>
        <div class="fs-14 text-white">
          <span class="fs-12">原价买</span>
          ¥{{live.price}}
          <!-- <span class="fs-12 m-price">¥{{live.nominalPrice}}</span> -->
        </div>
      </div>
      <div class="bg-white p-2 d-flex flex-column justify-content-around align-items-center">
        <div class="fs-14 themeFontColor">距拼购结束还剩</div>
        <div class="d-flex flex-row justify-content-around align-items-center">
          <div class="p-1 fs-14">{{time.d}}天</div>
          <div class="themeBGColor text-white p-1 fs-12">{{time.h>9?time.h:'0'+time.h}}</div>
          <div :style="{marginBottom:'0.08rem'}" class="p-1 fs-12">:</div>
          <div class="themeBGColor text-white p-1 fs-12">{{time.m>9?time.m:'0'+time.m}}</div>
          <div :style="{marginBottom:'0.08rem'}" class="p-1 fs-12">:</div>
          <div class="themeBGColor text-white p-1 fs-12">{{time.s>9?time.s:'0'+time.s}}</div>
        </div>
      </div>
    </div>

    <div class="headerdiv">
      <div class="headerdivTitle clamp">{{live.name}}</div>
      <div class="d-flex flex-row justify-content-between">
        <div class="headerdivText">{{viewNum}}人收听 {{live.startTime}}开始直播</div>
        <div
          class="headerdivPrice"
        >{{live.type==1?'免费':live.type==2?'¥'+live.price:live.type==3?'加密':''}}</div>
      </div>
    </div>

    <div class="c-list mt-2" v-if="live.marketingCampaignType==1">
      <div class="c-row flex-column align-items-start">
        <div class="fs-14 title">已经有{{live.memberCount}}人参与活动</div>
        <div
          v-for="(item,index) in live.groupBuy"
          :key="index"
          class="position-relative pt-1 pb-1 w-100 d-flex flex-row justify-content-between align-items-center"
        >
          <div
            :style="{width: (20+((item.groupBuyList.length<=2?item.groupBuyList.length:2))*20)+'px',height:'40px'}"
          >
            <div
              class="position-absolute d-flex flex-row align-items-center rounded-circle"
              :style="{height:'40px',width:'40px',left: cIndex*20+'px',border:'2px white solid'}"
              v-for="(cItem,cIndex) in item.groupBuyList"
              :key="cIndex"
              v-if="cIndex<=3"
            >
              <van-image lazy-load round width="36" height="36" :src="cItem.memberAvatar" />
            </div>
          </div>
          <div class="ml-3 flex-1">
            <div>
              <span>还差</span>
              <span class="themeFontColor">{{live.maxMemberCount-item.groupBuyList.length}}人</span>
              <span>参团</span>
            </div>
            <div v-if="groupEndTimes['item_'+item.groupBuyGroupId].time">
              <span>剩余</span>
              <span>{{groupEndTimes['item_'+item.groupBuyGroupId].time.d+'天'}}</span>
              <span>{{groupEndTimes['item_'+item.groupBuyGroupId].time.h>=10?groupEndTimes['item_'+item.groupBuyGroupId].time.h:'0'+groupEndTimes['item_'+item.groupBuyGroupId].time.h}}</span>
              <span>:</span>
              <span>{{groupEndTimes['item_'+item.groupBuyGroupId].time.m>=10?groupEndTimes['item_'+item.groupBuyGroupId].time.m:'0'+groupEndTimes['item_'+item.groupBuyGroupId].time.m}}</span>
              <span>:</span>
              <span>{{groupEndTimes['item_'+item.groupBuyGroupId].time.s>=10?groupEndTimes['item_'+item.groupBuyGroupId].time.s:'0'+groupEndTimes['item_'+item.groupBuyGroupId].time.s}}</span>
            </div>
          </div>
          <div
            class="pl-2 pr-2 pt-1 pb-1 themeBGColor text-white"
            :style="{borderRadius: '50px'}"
            @click="handleCommit(live.marketingCampaignType,item.groupBuyGroupId)"
          >去参团</div>
        </div>
      </div>
    </div>

    <div class="mt-2 tab d-flex flex-row justify-content-around">
      <div
        class="flex-1 flex-center title"
        :class="{select:tabIndex==0}"
        @click="changeTabIndex(0)"
      >直播详情</div>
      <div
        class="flex-1 flex-center title"
        :class="{select:tabIndex==1}"
        @click="changeTabIndex(1)"
      >讲师介绍</div>
    </div>
    <div class="headerdiv" v-show="tabIndex==0">
      <div style="width:100%;">
        <div class="htmlContent" v-html="live.description"></div>
      </div>
    </div>
    <div class="headerdiv" v-show="tabIndex==1">
      <div class="title mt">讲师介绍</div>
      <div class="mt d-flex flex-row justify-content-start align-items-center">
        <van-image
          lazy-load
          class="teacherAvater"
          width="60"
          height="60"
          round
          :src="teacher.avatar"
        />
        <div>
          <div class="title">{{teacher.teacherName}}</div>
          <div class="headerdivText">{{teacher.identity}}</div>
        </div>
      </div>
      <!-- <rich-text :nodes="live.description"></rich-text> -->
    </div>
    <div class="page-bottom">
      <router-link to="/" class="p-b-btn">
        <span class="yticon icon-xiatubiao--copy"></span>
        <span>首页</span>
      </router-link>
      <div class="action-btn-group flex-center">
        <div
          v-if="isSignUp||isTeacher"
          class="action-btn no-border buy-now-btn"
          @click="toLiveCode()"
        >进入教室</div>
        <div
          v-if="!isSignUp&&live.type==3&&!isTeacher"
          class="action-btn no-border buy-now-btn"
          @click="handlePwdAdd()"
        >立即报名</div>
        <div
          v-if="!isSignUp&&live.type==2&&!isTeacher&&live.marketingCampaignType==0"
          class="action-btn no-border buy-now-btn"
          @click="toPreOrder()"
        >立即购买</div>
        <div
          v-if="!isSignUp&&live.type==2&&!isTeacher&&live.marketingCampaignType==1"
          class="d-flex flex-row w-75 van-row--justify-space-around"
        >
          <div class="action-btn no-border buy-now-btn" @click="handleCommit()">
            <div class="fs-12" :style="{height:'14px'}">¥{{live.price}}</div>
            <div>单独购买</div>
          </div>
          <div
            class="action-btn no-border add-cart-btn"
            @click="handleCommit(live.marketingCampaignType)"
          >
            <div class="fs-12" :style="{height:'14px'}">¥{{live.groupLeaderPrice}}</div>
            <div>我要开团</div>
          </div>
        </div>
        <div
          v-if="!isSignUp&&live.type==2&&!isTeacher&&live.marketingCampaignType==2"
          class="d-flex flex-row w-75 van-row--justify-space-around"
        >
          <div
            class="action-btn no-border buy-now-btn"
            @click="handleCommit(live.marketingCampaignType)"
          >
            <div>立即购买</div>
          </div>
        </div>
        <div
          v-if="!isSignUp&&live.type==1&&!isTeacher"
          class="action-btn no-border buy-now-btn"
          @click="handleAdd()"
        >立即报名</div>
      </div>
    </div>
    <van-dialog v-model="imgDialog.show" :title="imgDialog.title">
      <van-image lazy-load class="image w-100" :src="imgDialog.base64" />
      <div class="text-center m-2 w-100 pl-3 pr-3 btnView">{{imgDialog.desc}}</div>
    </van-dialog>
    <van-dialog
      v-model="inputDialog.show"
      :title="inputDialog.title"
      show-cancel-button
      @confirm="handleAdd"
    >
      <input
        class="text-center w-100 p-3 p-3 btnView"
        v-model="inputDialog.value"
        placeholder="请输入密码"
      />
    </van-dialog>
  </div>
</template>

<script>
import {
  mapState,
  mapMutations
} from 'vuex';
export default {
  data () {
    return {
      tabIndex: 0,
      isSignUp: false,
      isTeacher: false,
      live: {},
      teacher: {},
      viewNum: 0,
      QRCode: '',
      password: '',
      imgDialog: {
        title: '',
        base64: '',
        desc: '',
        show: false
      },
      inputDialog: {
        title: '请输入直播间密码',
        value: '',
        show: false
      },
      time: {
        d: 0,
        h: 0,
        m: 0,
        s: 0
      },
      groupEndTimes: {},
      groupId: null
    };
  },

  mounted () {
    let query = this.$route.query
    this.id = query.id
    this.getLiveInfo()
  },
  computed: {
    ...mapState(['hasLogin', 'userInfo'])
  },
  destroyed () {
    clearInterval(this.timeIn)
  },
  methods: {
    share (title, desc, img) {
      let that = this
      that.$http.getJsSdkConfig().then(res => {
        that.updateShare(title, desc, img)
      })
    },
    updateShare (title, desc, img) {
      desc = desc ? desc : localStorage.getItem('desc')
      img = img ? img : localStorage.getItem('logo')
      let href = location.href
      let userId = localStorage.getItem('userId')
      if (userId) {
        if (href.indexOf('?') > -1) {
          href += '&userId=' + userId
        } else {
          href += '?userId=' + userId
        }
      }
      let share = {
        title: title, // 分享标题
        desc: desc || href, // 分享描述
        link: href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: img, // 分享图标
      }
      ///朋友和QQ
      window.wx.updateAppMessageShareData({
        ...share
      })
      ///朋友圈和空间
      window.wx.updateTimelineShareData({
        ...share
      })
      ///微博
      window.wx.onMenuShareWeibo({
        ...share
      });
    },
    setTitle (title) {
      document.title = title
    },
    changeTabIndex (index) {
      this.tabIndex = index
    },
    fomartHtmlImg () {
      let htmlContent = document.getElementsByClassName('htmlContent')[0]
      let imgs = htmlContent.getElementsByTagName('img')
      let screenWidth = document.body.clientWidth;
      imgs.forEach(element => {
        let width = element.getAttribute('width')
        if (width && width * 1 > screenWidth) {
          element.removeAttribute('width')
          element.removeAttribute('height')
        }
      });
    },
    getLiveInfo () {
      this.$http.request(this.$http.pathMap.liveInfo + this.id).then(res => {
        this.isSignUp = res.data.isSignUp
        this.isTeacher = res.data.isTeacher
        this.live = res.data.live
        this.teacher = res.data.teacher
        this.viewNum = res.data.viewNum
        this.setTitle(this.live.name)
        let that = this
        that.$nextTick(() => {
          that.share(that.live.name, that.live.intro, that.live.cover & that.live.cover.length > 0 ? that.live.cover[0] : '')
          that.fomartHtmlImg()
        })
        if (this.live.marketingCampaignType == 1) {
          this.startInterval1()
        }
        if (this.live.marketingCampaignType == 2) {
          this.startInterval2()
        }
      })
    },
    handlePwdAdd () {
      let inputDialog = this.inputDialog
      inputDialog.show = true
      this.inputDialog = inputDialog
    },
    handleAdd () {
      console.log('handleAdd')
      let that = this;
      let password = this.inputDialog.value
      if (!that.userInfo.phone) {
        this.$router.push({
          path: '/pages/public/bindPhone'
        })
        return;
      }
      that.$http.request(that.$http.pathMap.liveSignUp, 'post', { liveId: that.id, password: password }).then(res => {
        that.inputDialog.value = ''
        this.getLiveInfo()
        this.$dialog.confirm({
          title: '提示',
          message: '报名成功，是否进入教室?',
        }).then(() => {
          that.toLiveCode()
        })
      })
    },
    handleCommit (type, groupId) {
      this.type = type;
      this.groupId = groupId;
      if (groupId) {
        for (let item of this.live.groupBuy) {
          if (item.groupBuyGroupId == groupId) {
            for (let u of item.groupBuyList) {
              if (u.memberId == this.userInfo.id) {
                this.$toast('您已经参加该团，不能重复参加')
                return;
              }
            }
          }
        }
      }
      this.commit(type, groupId)
    },
    commit (marketingCampaignType, groupBuyGroupId) {
      let id = this.live.id;
      if (this.hasLogin) {
        let query = { id }
        if (marketingCampaignType) {
          query.marketingCampaignType = marketingCampaignType
        }
        if (groupBuyGroupId) {
          query.groupBuyGroupId = groupBuyGroupId
          for (let item of this.live.groupBuy) {
            if (item.groupBuyGroupId == groupBuyGroupId) {
              for (let u of item.groupBuyList) {
                if (u.memberId == this.userInfo.id) {
                  this.$toast('您已经参加该团，不能重复参加')
                  return;
                }
              }
            }
          }
        }
        this.$router.push({
          path: '/onlinePages/live/preLive',
          query
        })
      } else {
        this.$router.push('/pages/public/login')
      }
    },
    toPreOrder () {
      let id = this.live.id;
      this.$router.push({
        path: '/onlinePages/live/preLive',
        query: {
          id
        }
      })
    },
    toLiveCode () {
      let that = this
      that.$http.request(that.$http.pathMap.liveGetWxACode + that.id).then(res => {
        let qrCode = res.data.picture
        const base64 = qrCode.replace(/(\r\n)|(\n)|(\r)/g, '')
        let imgDialog = this.imgDialog
        imgDialog.title = '扫描或长按识别进入小程序'
        imgDialog.base64 = base64
        imgDialog.desc = res.data.identity
        imgDialog.show = true
        this.imgDialog = imgDialog
      })
    },
    startInterval1 () {
      //总倒计时
      this.serverTime = new Date(this.live.serverTime.replace(/-/g, "/")).getTime()
      this.groupEndTime = new Date(this.live.marketingCampaignEndTime.replace(/-/g, "/")).getTime()
      this.groupEndTimes = {}
      for (let item of this.live.groupBuy) {
        let endTime = new Date(item.dueTime.replace(/-/g, "/")).getTime()
        this.groupEndTimes['item_' + item.groupBuyGroupId] = { endTime, time: { d: 0, h: 0, m: 0, s: 0 } }
      }
      let that = this
      that.timeIn = setInterval(() => {
        that.serverTime += 500
        let time = that.computeTime(this.serverTime, this.groupEndTime)
        if (time) {
          this.time = time
        } else {
          // this.getProduct()
        }
        for (let key in that.groupEndTimes) {
          let endTime = that.groupEndTimes[key].endTime
          let time = that.computeTime(that.serverTime, endTime)
          if (time) {
            that.groupEndTimes[key].time = time
          } else {
            // this.getProduct()
          }
        }
      }, 500)
    },
    startInterval2 () {
      //总倒计时
      this.serverTime = new Date(this.live.serverTime.replace(/-/g, "/")).getTime()
      this.groupEndTime = new Date(this.live.marketingCampaignEndTime.replace(/-/g, "/")).getTime()
      let that = this
      that.timeIn = setInterval(() => {
        that.serverTime += 500
        let time = that.computeTime(this.serverTime, this.groupEndTime)
        if (time) {
          this.time = time
        } else {
          // this.getProduct()
        }
      }, 500)
    },
    computeTime (startTime, endTime) {
      if (startTime >= endTime) {
        return false
      }
      let SS = Math.floor(endTime - startTime) / 1000
      let d = parseInt(SS / (3600 * 24))
      let h = parseInt((SS - (d * 3600 * 24)) / 3600)
      let m = parseInt((SS - (d * 3600 * 24) - (h * 3600)) / 60)
      let s = parseInt((SS - (d * 3600 * 24) - (h * 3600) - (m * 60)))
      return {
        d, h, m, s
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.containerdiv {
  padding-bottom: 67px;
}
.smallVideodiv {
  position: relative;
  width: 100%;
  // height: 230px;
}
.headerdiv {
  padding: 10px;
  background-color: white;
}

.headerdivTitle {
  font-size: $uni-font-size-lg;
  color: $uni-text-color;
  line-height: 16px;
}

.headerdivText {
  margin-top: 10px;
  font-size: $uni-font-size-base;
  color: $uni-text-color-grey;
  line-height: 1;
}

.headerdivPrice {
  margin-top: 10px;
  font-size: $uni-font-size-lg + 2px;
  color: var(--theme-font-color);
  line-height: 1;

  // &:before {
  // 	content: '￥';
  // 	font-size: 26upx;
  // }
}
.tab {
  height: 40px;
  border-top: 1px $uni-border-color-base solid;
  border-bottom: 1px $uni-border-color-base solid;
  background-color: white;
}

.teacherAvater {
  margin-right: 10px;
}

.title {
  font-size: $uni-font-size-lg;
  color: $uni-text-color;
}

.desc {
  font-size: $uni-font-size-base;
  color: $uni-text-color;
}

.select {
  color: var(--theme-font-color);
  border-bottom: 3px var(--theme-font-color) solid;
}

.selectText {
  color: var(--theme-font-color);
}
.mt {
  margin-top: 10px;
}
/* 底部操作菜单 */
.page-bottom {
  position: fixed;
  left: 0px;
  bottom: 15px;
  z-index: 95;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 30px);
  margin: 0 15px;
  height: 50px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);
  border-radius: 8px;

  .p-b-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: $uni-font-size-sm;
    color: $font-color-base;
    width: 48px;
    height: 40px;

    .yticon {
      font-size: 20px;
      line-height: 25px;
      color: $font-color-light;
    }

    &.active,
    &.active .yticon {
      color: var(--theme-font-color);
    }

    .icon-fenxiang2 {
      font-size: 21px;
      transform: translateY(-1px);
    }

    .icon-shoucang {
      font-size: 23px;
    }
  }

  .action-btn-group {
    display: flex;
    flex: 1;
    height: 38px;
    border-radius: 100px;
    overflow: hidden;
    box-shadow: 1px 2px 5px rgba(219, 63, 96, 0.4);
    background: var(--theme-font-color);
    margin-left: 10px;
    margin-right: 10px;

    .action-btn {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 90px;
      height: 100%;
      font-size: $uni-font-size-base;
      color: white;
      padding: 0;
      border-radius: 0;
      background: transparent;
    }
  }
}
.c-list {
  font-size: $uni-font-size-sm + 1px;
  color: $font-color-base;
  background: #fff;

  .c-row {
    display: flex;
    align-items: center;
    padding: 10px 15px;
    position: relative;
  }

  .tit {
    min-width: 70px;
    max-width: 100px;
    text-align: left;
  }

  .con {
    flex: 1;
    text-align: left;
    color: $font-color-dark;

    .selected-span {
      margin-right: 5px;
    }
  }

  .bz-list {
    height: 20px;
    font-size: $uni-font-size-sm + 1px;
    color: $font-color-dark;

    span {
      display: inline-block;
      margin-right: 15px;
    }
  }

  .con-list {
    flex: 1;
    display: flex;
    flex-direction: column;
    color: $font-color-dark;
    line-height: 20px;
  }

  .red {
    color: var(--theme-font-color);
  }
}
.titleView {
  font-size: 16px;
}

.btnView {
  font-size: 16px;
}
</style>
